import { createReducer } from "@reduxjs/toolkit";
import {InitialState} from './InitialState'
const Reducer=createReducer(InitialState,
{
      'SET_PAGE':(state,action)=>{
         state.page=action.payload;
      }
});
export default Reducer;